// Custom scripts
import ListaTowarow from "./listatowarow";

(() => {
  if (typeof $ === "undefined") {
    throw new TypeError("... requires jQuery.");
  }

  $(document).ready(() => {
    const lt = new ListaTowarow();

    lt.init();
  });
})();
